import {
  formatFoobarReference,
  extractFoobarReference
} from '../../utils/foobar';

class Serializer {
  normalize = payload => {
    let nwCorner = (((((payload || {}).assetInfo || {}).metadata || {}).props || {}).nwCorner || '').split(',');    
    let seCorner = (((((payload || {}).assetInfo || {}).metadata || {}).props || {}).seCorner || '').split(',');
    return {
      id: payload.id,
      name: payload.name,
      account: payload.account && {
        id: extractFoobarReference(payload.account),
        href: payload.account.href
      },
      file: {
        href: payload.self.href,
        imgData: payload.data? `data:image/png;base64,${payload.data}`: ''
      },
      nwCorner: {
        lat: +nwCorner[1],
        lng: +nwCorner[0]
      },
      seCorner: {
        lat: +seCorner[1],
        lng: +seCorner[0]
      }
    };
  };
  serialize = mapping => {
    return {
      name: mapping.name,
      account: formatFoobarReference(mapping.account.href),
      siteId: mapping.site.id,
      fileUrl: mapping.file.href,
      nwCorner: {
        latitude: mapping.nwCorner.lat,
        longitude: mapping.nwCorner.lng
      },
      seCorner: {
        latitude: mapping.seCorner.lat,
        longitude: mapping.seCorner.lng
      }
    };
  };
}

export const IndoorMappingSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/indoorMapping/index.js